import urlApi from './urlApi';
export var HOME_WORK_REQUEST = 'HOME_WORK_REQUEST';
export var HOME_WORK_SUCCESS = 'HOME_WORK_SUCCESS';
export var HOME_WORK_RESET = 'HOME_WORK_RESET';
export var HOME_WORK_UPDATE = 'HOME_WORK_UPDATE';
export function sendHomeWorkAction(data, isMultiple, isSlider) {
    return function (dispatch) {
        dispatch({
            type: HOME_WORK_REQUEST,
        });
        urlApi().addNewHomeWorkPost(data, isMultiple, isSlider).then(function (res) {
            dispatch({
                type: HOME_WORK_SUCCESS,
                payload: res,
            });
        });
    };
}
export function setHomeWorkAction(data) {
    return function (dispatch) {
        dispatch({
            type: HOME_WORK_UPDATE,
            payload: data,
        });
    };
}
export function UpdateHomeWorkAction(data) {
    return function (dispatch) {
        dispatch({
            type: HOME_WORK_UPDATE,
            payload: data,
        });
    };
}
export function resetHomeWorkAction() {
    return function (dispatch) {
        dispatch({
            type: HOME_WORK_RESET,
            payload: [],
        });
    };
}
//# sourceMappingURL=homeworkAction.js.mapimport urlApi from './urlApi';
export var HOME_WORK_REQUEST = 'HOME_WORK_REQUEST';
export var HOME_WORK_SUCCESS = 'HOME_WORK_SUCCESS';
export var HOME_WORK_RESET = 'HOME_WORK_RESET';
export var HOME_WORK_UPDATE = 'HOME_WORK_UPDATE';
export function sendHomeWorkAction(data, isMultiple, isSlider) {
    return function (dispatch) {
        dispatch({
            type: HOME_WORK_REQUEST,
        });
        urlApi().addNewHomeWorkPost(data, isMultiple, isSlider).then(function (res) {
            dispatch({
                type: HOME_WORK_SUCCESS,
                payload: res,
            });
        });
    };
}
export function setHomeWorkAction(data) {
    return function (dispatch) {
        dispatch({
            type: HOME_WORK_UPDATE,
            payload: data,
        });
    };
}
export function UpdateHomeWorkAction(data) {
    return function (dispatch) {
        dispatch({
            type: HOME_WORK_UPDATE,
            payload: data,
        });
    };
}
export function resetHomeWorkAction() {
    return function (dispatch) {
        dispatch({
            type: HOME_WORK_RESET,
            payload: [],
        });
    };
}
//# sourceMappingURL=homeworkAction.js.map